import { render, staticRenderFns } from "./VuesticPageNotFoundCustom.vue?vue&type=template&id=6a275bfa&"
import script from "./VuesticPageNotFoundCustom.vue?vue&type=script&lang=js&"
export * from "./VuesticPageNotFoundCustom.vue?vue&type=script&lang=js&"
import style0 from "./VuesticPageNotFoundCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticPageNotFoundCustom.vue"
export default component.exports